/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const Checkbox = ({ variant, label, className, boxClassName }) => {
  return (
    <div className={`checkbox ${className}`}>
      <div className={`box ${boxClassName}`} />
    </div>
  );
};

Checkbox.propTypes = {
  variant: PropTypes.oneOf(["not-selected"]),
  label: PropTypes.oneOf(["none"]),
};
